module.exports = __webpack_public_path__ + "img/bk-warranty-1920.ebe72d71.jpg";